import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const TranslationsIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="m12.8 14.88-2.32-2.28.03-.03a16.02 16.02 0 0 0 3.37-5.93h2.67V4.82h-6.37V3H8.36v1.82H2v1.8h10.15a14.28 14.28 0 0 1-2.88 4.88 14.22 14.22 0 0 1-2.1-3.05H5.35a15.96 15.96 0 0 0 2.71 4.15l-4.62 4.56 1.29 1.3 4.54-4.55 2.83 2.83.7-1.86Zm5.1-4.6h-1.8L12 21.17h1.82l1.02-2.73h4.31l1.03 2.73H22l-4.1-10.9ZM17 12.7l-1.47 3.94h2.94L17 12.7Z" />
    </SvgIcon>
);
